import { Action } from '@reduxjs/toolkit';

import { logout } from 'app/redux/actions/auth';

import {
  CLOSE_ALL_ENTITIES, CLOSE_ENTITY, CloseAllEntities,
  CloseEntity,
  OPEN_ALL_ENTITIES, OPEN_ENTITY, OpenAllEntities,
  OpenEntity,
} from '../actions/sidebarPreferences';
import { SidebarPreferencesState } from '../types/sidebarPreferences';

// ---

const initialState: SidebarPreferencesState = {
  isOpened: true,
  openedEntities: new Map(),
};

type LogoutSuccess = Action<typeof logout.fulfilled>;

type Actions =
  | OpenAllEntities
  | CloseAllEntities
  | OpenEntity
  | LogoutSuccess
  | CloseEntity;

// ---

function setIsOpened(
  state: SidebarPreferencesState,
  activeIds: number[],
  isOpened: boolean,
): SidebarPreferencesState {
  const openedEntities = new Map(state.openedEntities);
  activeIds.forEach((id) => {
    openedEntities.set(id, isOpened);
  });

  return {
    ...state,
    isOpened,
    openedEntities,
  };
}

function setOpenedEntitiesState(
  state: SidebarPreferencesState,
  payload: OpenEntity['payload'] | CloseEntity['payload'],
  value: boolean,
): SidebarPreferencesState {
  const openedEntities = new Map(state.openedEntities);

  if (Array.isArray(payload.ids)) {
    payload.ids.forEach((id) => {
      openedEntities.set(id, value);
    });
  }
  else {
    openedEntities.set(payload.ids, value);
  }

  return {
    ...state,
    openedEntities,
  };
}

export default function (state = initialState, action: Actions): SidebarPreferencesState {
  switch (action.type) {
    case OPEN_ALL_ENTITIES:
      return setIsOpened(state, action.payload, true);

    case CLOSE_ALL_ENTITIES:
      return setIsOpened(state, action.payload, false);

    case OPEN_ENTITY:
      return setOpenedEntitiesState(state, action.payload, true);

    case CLOSE_ENTITY:
      return setOpenedEntitiesState(state, action.payload, false);

    case logout.fulfilled.type:
      return initialState;

    default:
      return state;
  }
}
